import React, { Component } from "react";
import { BlueBtn } from "components/Controls";
import { connect } from "react-redux";
import { selectOffer, nextStep } from "../../actions";
import { BuyoutInfo, OfferView } from "components/DataDisplay";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { AnalyticAPI } from "api/analytic";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import {
  appRequestSelector,
  trendingsVisitID,
} from "../../selectors";
import { createStructuredSelector } from "reselect";
import OfferHeader from "../OfferHeader";
import { buildOfferData, kafeneWeeksToMonths } from "containers/MultistepForm/helpers";
import { addThousandsSeparator, capitalizeFirstletter, paymentFrequency } from 'utils/helpers';

import "./styles.scss";

class KafeneOffer extends Component {
  state = {
    loading: false,
  };

  componentDidMount = () => {
    const { offer } = this.props;
    const option = offer.options[0];
    this.setSelected(option);
  };

  setSelected = (option) => {
    const { offer } = this.props;
    const selected = {
      ...option,
      app_id: offer.app_id,
      provider: offer.provider,
      banking_data: offer.banking_data,
      specific_provider_name: offer.specific_provider_name,
      payment_schedule: offer.payment_schedule,
      cart_total: offer.cart_total,
      approved_amount: offer.approved_amount,
    };
    this.props.getSelectedOffer(selected);
    this.setState({ selectedOption: selected });
  };

  submitForm = () => {
    const { selectOffer, offer, logContinueEvent, token, visitID } = this.props;
    const { selectedOption } = this.state;

    AnalyticAPI.send_provider_analytic_event(
      token,
      'select_provider',
      'kafene',
      visitID
    );

    logContinueEvent();

    this.setState({ loading: true });
    selectOffer({
      selectedOffer: selectedOption,
      body: { offer_id: selectedOption.offer_id },
    });
  };

  renderTermsAndConditions = () => {
    const { offer } = this.props;
    const termsAndConditions = offer.options?.[0]?.terms_and_conditions;

    if (!termsAndConditions?.length) return null;

    return termsAndConditions
      .filter(term => term.key !== 'promo')
      .map((term) => (
        <BuyoutInfo
          key={term.key}
          title={term.header}
          text={term.body || ''}
          footnote={term.footer}
        />
      ));
  };

  renderPromoInfo = () => {
    const { offer } = this.props;
    const termsAndConditions = offer.options?.[0]?.terms_and_conditions;
    const promoTerm = termsAndConditions?.find(term => term.key === 'promo');

    if (!offer.promo || !promoTerm) return null;

    return (
      <BuyoutInfo
        title={promoTerm.header}
        text={promoTerm.body || ''}
        footnote={promoTerm.footer}
      />
    );
  };

  render() {
    const { loading, selectedOption } = this.state;
    const { handleSubmit, valid, available, isExpanded, offer, toggleExpanded } = this.props;

    if (!selectedOption) {
      return '';
    }

    const baseValue = selectedOption.initial_payment_base ?? 0;
    const baseAmount = addThousandsSeparator(baseValue);

    const dueToday =
      baseValue > 0
        ? { amount: baseAmount, info: '(+ taxes)' }
        : baseAmount;

    return (
      <div className="expanded-block-component__expanded-content">
        <OfferHeader
          available={available}
          isExpanded={isExpanded}
          dueToday={dueToday}
          specificProviderName={offer.specific_provider_name}
          paymentPeriod={`${kafeneWeeksToMonths(selectedOption.payment_period)} Months`}
          paymentFrequency={paymentFrequency(selectedOption)}
          approvedAmount={offer.approved_amount}
          typeOfPlan={selectedOption.type}
          toggleExpanded={toggleExpanded}
          promo={offer.promo}
        />
        {isExpanded && (
          <form
            onSubmit={handleSubmit(this.submitForm)}
            className="kafene-offer application-offer"
          >
            <div className="step3__recommended-offer-plan offer-plan__top flex flex--wrap">
              <OfferView offerData={buildOfferData(selectedOption)} />
            </div>
            {this.renderPromoInfo()}
            {this.renderTermsAndConditions()}
            <BlueBtn
              customClass="step3__recommended-content-btn"
              loading={loading}
              disabled={!available || !valid}
              type="submit"
            >
              Continue with{' '}
              {capitalizeFirstletter(offer.specific_provider_name)}
            </BlueBtn>
          </form>
        )}
      </div>
    );
  }
}

KafeneOffer.propTypes = {
  offer: PropTypes.object.isRequired,
  available: PropTypes.bool,
};

KafeneOffer.defaultProps = {
  available: true,
};

const mapStateToProps = createStructuredSelector({
  token: tokenSelector(),
  appRequest: appRequestSelector(),
  visitID: trendingsVisitID(),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
    nextStep: (value) => dispatch(nextStep(value)),
  };
};

KafeneOffer = connect(
  mapStateToProps,
  mapDistpatchToProps
)(KafeneOffer);

KafeneOffer = reduxForm({
  form: "form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(KafeneOffer);

export default KafeneOffer;
